import { useEffect } from "react";

import { segmentPage } from "util/segment";
import { useIsAuthenticated } from "common/authentication";

import {
  getFlowType,
  type FlowTypeArgs,
  useSignerMarketingSessionMutation,
  writeMarketingFlowType,
} from "./util";

export function setAnalyticsFlowType(args: FlowTypeArgs) {
  writeMarketingFlowType(getFlowType(args));
}

export function useSignerAnalyticsPage(args: FlowTypeArgs) {
  const { isRetail, isMortgage, skipStoreSession } = args;
  const isAuthenticated = useIsAuthenticated();
  const storeMarketingSessionFn = useSignerMarketingSessionMutation();

  useEffect(() => {
    const type = getFlowType(args);
    !skipStoreSession && writeMarketingFlowType(type);
    !skipStoreSession && storeMarketingSessionFn(isAuthenticated);
    segmentPage({ flow_type: type });
  }, [isRetail, isMortgage]);
}
